import { render, staticRenderFns } from "./regionalCenterForm.vue?vue&type=template&id=6d9c2e00&scoped=true&"
import script from "./regionalCenterForm.vue?vue&type=script&lang=js&"
export * from "./regionalCenterForm.vue?vue&type=script&lang=js&"
import style0 from "./regionalCenterForm.vue?vue&type=style&index=0&id=6d9c2e00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c2e00",
  null
  
)

export default component.exports